"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
import { SpinnerSize, Constant, SpinnerSizeMap } from "../constants.js";
import { StyledCircularProgress, StyledText } from "../styles.js";
const Activity = ({
  label,
  hasLabel,
  size,
  spinnerColor
}) => {
  const activityRef = useRef(null);
  const showText = hasLabel && size === SpinnerSize.Large;
  const [isReduceMotion, setIsReduceMotion] = useState();
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsReduceMotion(
        (window == null ? void 0 : window.matchMedia(Constant.ReducedMotion).matches) === true
      );
    }
  }, []);
  useEffect(() => {
    if (activityRef.current) {
      const svgEl = activityRef.current.querySelector("svg");
      svgEl == null ? void 0 : svgEl.setAttribute("aria-hidden", "true");
      svgEl == null ? void 0 : svgEl.setAttribute("focusable", "false");
    }
  }, [activityRef]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      StyledCircularProgress,
      {
        role: "status",
        "aria-labelledby": Constant.TextID,
        size: SpinnerSizeMap[size],
        ref: activityRef,
        style: { color: spinnerColor }
      }
    ),
    /* @__PURE__ */ jsx(
      StyledText,
      {
        role: isReduceMotion ? "status" : void 0,
        id: Constant.TextID,
        variant: isReduceMotion ? "bodyCopy" : "t4",
        showText,
        children: label
      }
    )
  ] });
};
export {
  Activity
};
